import { BASE_API_URL, handleAPIResponse } from './Base';

export async function getDam(damKey) {
  const response = await fetch(`${BASE_API_URL}/dams/${damKey}`)
  return await handleAPIResponse(response)
}

export async function getDamData(damKey) {
  const response = await fetch(`${BASE_API_URL}/dams/${damKey}/data`)
  return await handleAPIResponse(response)
}

